var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "viewer-fade" } }, [
    _c("div", { staticClass: "el-image-viewer__wrapper" }, [
      _c("div", { staticClass: "el-image-viewer__mask" }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "el-image-viewer__btn el-image-viewer__close",
          on: { click: _vm.hide },
        },
        [_c("i", { staticClass: "el-icon-close" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "el-image-viewer__img-wrapper" },
        _vm._l(_vm.urlList, function (url, i) {
          return _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: i === _vm.index,
                expression: "i === index",
              },
            ],
            key: url,
            staticClass: "el-image-viewer__img",
            style: _vm.imgStyle,
            attrs: { src: url },
            on: {
              load: _vm.handleImgLoad,
              error: _vm.handleImgError,
              click: _vm.hide,
            },
          })
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }